import api from "../../axios/api.js";

export class SearchListService {
  async getSearchList() {
    const data = await api.get("SearchList");
    return data;
  }
}
